<template>
  <section class="main-contents-wrapper">
    <h2 class="limit-page-title">베팅·당첨 한도</h2>
    <div class="tab-wrap">
      <button type="button" class="tab-item" :class="{ active: mode === 'site' }" :aria-pressed="mode === 'site'" @click="mode = 'site'">사이트 공통 한도</button>
      <button type="button" class="tab-item" :class="{ active: mode === 'member' }" :aria-pressed="mode === 'member'" @click="mode = 'member'">회원별 한도</button>
      <button type="button" class="tab-item" :class="{ active: mode === 'list' }" :aria-pressed="mode === 'list'" @click="mode = 'list'">개별 설정 회원 목록</button>
    </div>
    <bet-limit-settings v-if="mode === 'site'" />
    <template v-else-if="mode === 'member'">
      <form class="member-limit-search" @submit.prevent="findMember">
        <label>회원 ID <input v-model="memberSearch" type="text" autocomplete="off" @input="clearMember" /></label>
        <button type="submit" class="btn-search">조회</button>
      </form>
      <p v-if="searchError" role="alert">{{ searchError }}</p>
      <template v-if="memberId">
        <p class="member-limit-target">조회 회원: <strong>{{ memberId }}</strong></p>
        <bet-limit-settings :key="memberId + ':' + lookupVersion" :member-id="memberId" />
      </template>
      <p v-else-if="!searchError" class="member-limit-target">회원 ID를 조회하면 카지노·슬롯의 개별 한도와 공통값 상속 여부를 확인할 수 있습니다.</p>
    </template>
    <member-bet-limit-list v-else @open-member="openMember" />
  </section>
</template>

<script>
import BetLimitSettings from '@/components/common/BetLimitSettings'
import MemberBetLimitList from '@/components/common/MemberBetLimitList'

export default {
  name: 'BetLimitSetting',
  components: { BetLimitSettings, MemberBetLimitList },
  data () {
    return { mode: 'site', memberSearch: '', memberId: '', lookupVersion: 0, searchError: '' }
  },
  methods: {
    openMember (memberId) {
      this.memberSearch = memberId
      this.findMember()
      this.mode = 'member'
    },
    clearMember () {
      this.memberId = ''
      this.searchError = ''
    },
    findMember () {
      this.clearMember()
      const memberId = this.memberSearch.trim()
      if (!memberId) {
        this.searchError = '조회할 회원 ID를 입력해주세요.'
        return
      }
      this.memberId = memberId
      this.lookupVersion++
    }
  }
}
</script>

<style scoped>
.limit-page-title {font-size: 20px;margin: 12px 0 20px;}
.member-limit-search {display: flex;align-items: center;gap: 10px;margin: 20px 0;}
.member-limit-search label {display: flex;align-items: center;gap: 10px;}
.member-limit-search input {padding: 8px;border: 1px solid #64748b;background: #1f2937;color: #fff;}
.member-limit-target {margin: 16px 0;color: #cbd5e1;line-height: 1.6;}
.member-limit-search input:focus-visible {outline: 2px solid #93c5fd;outline-offset: 2px;}
</style>
